<template>
  <div class="AboutVue">
    <div>
      <div class="section five">
        <img src="../assets/image/bannera1.png" alt="" class="five-img">
        <h3>关于我们</h3>
        <p class="p">
          我们是一家致力于解决健身管理痛点的SaaS软件服务商，以“工具+服务+模式”为运<br>
          动健身实体门店智慧赋能，以科技助力产业升级。依托云计算、大数据等技术手段，<br>
          不断专研前沿科技，建立全生态服务体系，帮助传统线下门店实现科学高效的新型管<br>
          理模式，并最终助力企业提效增收，同时给用户带来前所未有的便捷和体验。
        </p>
      </div>
      <div>
        <div class="section two">
          <div class="tow-box">
            <el-row :gutter="90">
              <el-col :span="8">
                <div class="tow-item">
                  <div class="tow-text1">Value of customer</div>
                  <div class="tow-text2"> 客户价值 </div>
                  <div class="tow-text3">以产业需求为核心，<br>
                    利用先进技术为客户提供真实价值，赋能健身行业从业者，<br>与用户携手成长。</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="tow-item">
                  <div class="tow-text1">Employee value</div>
                  <div class="tow-text2"> 员工价值 </div>
                  <div class="tow-text3">以人为本，为员工搭建良好<br>的发展
                    平台，激发每一位健身员工的内在潜力，将创新的理念渗透到每个人、
                    每件事、每一项服务。 </div>
                </div>

              </el-col>
              <el-col :span="8">
                <div class="tow-item">
                  <div class="tow-text1">Social value</div>
                  <div class="tow-text2"> 社会价值 </div>
                  <div class="tow-text3">以星星之火为起点，<br>
                    发挥健身员工的光与热，与优秀的行业同仁一起为创造更美好的<br>未来而不断奋斗。</div>
                </div>

              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="three" id="three">
        <img src="../assets/image/bannera2.png" alt="" class="three-img">
        <div class="three-h3">企业文化</div>
        <div class="three-box">
          <el-row :gutter="20">
            <el-col :span="8" class="three-box-item">
              <img src="../assets/image/icona1.png" alt="" class="three-icon">
              <div class="three-text1">使命</div>
              <div class="three-text2">让教练赢得尊重；让健身房获得盈利</div>
            </el-col>
            <el-col :span="8" class="three-box-item">
              <img src="../assets/image/icona2.png" alt="" class="three-icon">
              <div class="three-text1">愿景</div>
              <div class="three-text2">为客户创造价值；为健身行业者赋能</div>

            </el-col>
            <el-col :span="8" class="three-box-item">
              <img src="../assets/image/icona3.png" alt="" class="three-icon">
              <div class="three-text1">价值观</div>
              <div class="three-text2">担当/合作/积极/务实</div>

            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <FooterVue class="section"></FooterVue>
  </div>
</template>

<script setup>
import FooterVue from '../components/FooterVue.vue';

import { defineEmits } from 'vue';
const changeColor = defineEmits(['changeColor']);
changeColor('changeColor', true)

// 
window.addEventListener('scroll', function () {
  const threshold = document.getElementById('three').offsetTop 
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop; 
  // 在这里编写需要执行的代码
  if (scrollTop >= threshold) {
    changeColor('changeColor', '')
  } else {
    changeColor('changeColor', true)
  }
});
</script>

<style lang="scss">
@import '@/assets/css/style.css';

.AboutVue {
  .fp-overflow {
    height: 100%;
  }

  .one-footer {
    position: inherit;
  }

  .section {
    height: 100%;
  }


  .two {
    z-index: 3;
    position: relative;
    margin-top: -7%;
    padding-bottom: 111px;

    .tow-box {
      width: calc(100% - 300px);
      position: relative;
      left: 0;
      right: 0;
      bottom: 10%;
      margin: auto;

      .tow-item {
        height: 100%;
        box-sizing: border-box;
        padding: 25% 15%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        box-shadow: 10px 0px 50px 0px #DFDFDF;
        border-radius: 20px;
        background: #FFFFFF;
        text-align: center;


        img {
          width: 127px;
          height: 124px;
          margin-bottom: 50px;
        }

        div {
          font-size: 1.8vw;
          font-family: AlibabaPuHuiTi-Regular;
          font-weight: 400;
          color: #292829;
          line-height: 36px;
        }

        .tow-text1 {
          font-size: 1.14vw;
          font-family: AlibabaPuHuiTi-Regular;
          font-weight: 400;
        }

        .tow-text2 {
          font-size: 1.87vw;
          font-family: AlibabaPuHuiTi-Bold;
          font-weight: bold;
          margin-top: 10px;
        }

        .tow-text3 {
          font-size: 1.14vw;
          margin-top: 40px;
          font-family: AlibabaPuHuiTi-Light;
          font-weight: 400;
          line-height: 40px;
        }
      }

      .tow-item:hover {
        background: rgba(229, 10, 51, 1);

        div {
          color: #FFFFFF;
        }
      }
    }

    h3 {
      font-size: 3vw;
      font-family: AlibabaPuHuiTi-Medium;
      font-weight: 500;
      color: #000000;
      text-align: left;
      z-index: 1;
      width: calc(100% - 360px);
      margin: 160px auto 0;
    }

    h3::before {
      width: 2.5vw;
      height: 2.5vw;
      content: "";
      position: absolute;
      border: 10px solid #E50A33;
      border-radius: 50%;
      margin-top: -1vw;
      margin-left: -1.8vw;
      z-index: -1;
    }

    .p {
      font-size: 1.14vw;
      font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
      font-weight: 400;
      color: #333333;
      width: calc(100% - 360px);
      margin: 30px auto 0;
    }
  }

  .five {
    overflow: hidden;
    position: relative;
    width: 100%;

    .five-img {
      width: 100%;
      z-index: 0;
      position: relative;
    }

    .fRight {
      position: absolute;
      right: 15vw;
      top: 0;
      bottom: 0;
      margin: auto;
      height: 50%;
    }

    h3::before {
      width: 2.5vw;
      height: 2.5vw;
      content: "";
      position: absolute;
      border: 10px solid #E50A33;
      border-radius: 50%;
      margin-top: -1vw;
      margin-left: -1.8vw;
      z-index: -1;
    }

    h3 {
      font-size: 3.64vw;
      font-family: AlibabaPuHuiTi-Medium;
      font-weight: 500;
      color: #000000;
      position: absolute;
      top: 30%;
      left: 10%;
      z-index: 3;
      width: 50%;
    }

    .p {
      font-size: 1.14vw;
      font-family: AlibabaPuHuiTi-Light;
      font-weight: 400;
      color: #333333;
      position: absolute;
      z-index: 2;
      left: 10%;
      margin-top: 49px;
      line-height: 40px;
      top: 45%;
    }
  }

  .three {
    overflow: hidden;
    position: relative;
    width: 100%;
    margin: 0px;

    .three-h3 {
      font-size: 3.64vw;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 500;
      color: #FFFFFF;
      position: absolute;
      top: 10%;
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;

    }

    .three-img {
      width: 100%;
      z-index: 0;
      position: relative;
    }

    .three-box {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      margin: auto;
      z-index: 3;
      width: calc(100% - 300px);
      box-sizing: border-box;
      height: 10%;

      .three-box-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .three-icon {
          height: 83px;
        }

        .three-text1 {
          font-size: 48px;
          font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
          font-weight: 500;
          color: #FFFFFF;
          margin: 30px auto;
        }

        .three-text2 {
          font-size: 22px;
          font-family: AlibabaPuHuiTi-Light, AlibabaPuHuiTi;
          font-weight: 300;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>
